
//############################  Inventory Endpoints ############################//

export const GET_CATEGORIES_BASE_URL = "/inventory/get-category"
export const UPSERT_CATEGORIES_BASE_URL = "/inventory/upsert-category"

export const GET_PRODUCT_BASE_URL = "/inventory/get-product"
export const UPSERT_PRODUCT_BASE_URL = "/inventory/upsert-product"

export const GET_PRODUCT_CUSTOMIZATION_BASE_URL = "/inventory/get-customization"
export const UPSERT_PRODUCT_CUSTOMIZATION_BASE_URL = "/inventory/upsert-customization"

export const GET_PRODUCT_MODIFIER_BASE_URL = "/inventory/get-product-modifier"
export const UPSERT_PRODUCT_MODIFIER_BASE_URL = "/inventory/upsert-product-modifier"

export const GET_INVENTORY_BASE_URL = "/inventory/get-inventory"
export const UPSERT_INVENTORY_BASE_URL = "/inventory/upsert-inventory"

//############################  Menu Endpoints ############################//

export const IMPORT_MENU_ITEMS_AS_EXCEL = "/menu/import-menu-as-csv" //
export const UPDATE_MENU_ITEMS_VIA_EXCEL = "/menu/update-menu-via-csv"

//############################  Orders Endpoints ############################//
export const GET_ORDERS_BASE_URL = "/order/get-order"
export const UPSERT_ORDERS_BASE_URL = "/order/upsert-order"

export const server_base_endpoints = {
    general: {
        get_table_or_column_name: "/general/get-table-or-column-name"
    },
    templates: {
        get_templates: "/templates/get-templates",
        upsert_template: "/templates/edit-templates",
        render_template: "/templates/render-template",
        get_table_or_column_name: "/templates/get-sql-view-or-columns",
        upsert_table_or_column_name: "/templates/get-sql-view-or-columns",
        get_sql_view_or_columns: "/templates/get-sql-view-or-columns",
        upsert_sql_view_or_columns: "/templates/get-sql-view-or-columns",
        upsert_email_body_template_mapping: "/template/upsert-email-body-template-mapping",
        get_table_or_column_nam: "/template/get-table-or-column-name",
        get_whatsapp_exotel_template: "/template/get-whatsapp-exotel-template",
        upsert_whatsapp_template: "/template/upsert-whatsapp-template",
    },
    workflow: {
        upsert_workflow_basic: "/workflow/upsert-workflow-basic",
        get_workflow_basic: "/workflow/get-workflow-basic",
        upsert_workflow_condition: "/workflow/upsert-workflow-condition",
        get_workflow_condition: "/workflow/get-workflow-condition",
        upsert_workflow_action: "/workflow/upsert-workflow-action",
        get_workflow_action: "/workflow/get-workflow-action",
        upsert_workflow_action_email: "/workflow/upsert-workflow-action-email",
        get_workflow_action_email: "/workflow/get-workflow-action-email",
        upsert_workflow_action_message: "/workflow/upsert-workflow-action-message",
        get_workflow_action_message: "/workflow/get-workflow-action-message",
        get_workflow_all_definition: "/workflow/get-workflow-all-definition",
        workflow_initiate: "/workflow/workflow-initiate",
    },
    settings: {
        payment_gateway: {
            upsert_payment_gateway: "/payment/upsert-payment-gateway",
            get_payment_gateway: "/payment/get-payment-gateway",
        }
    }
}